import React, { useState, useEffect } from "react";
import api from '../../assets/constants/Rafservice.Instance';
import WidgetCard from "../../components/Cards/WidgetCard";
import SingleVerticalBarChart from '../../components/Charts/SingleVerticalBar.Chart';
import AcaYearSelect from '../../components/DropDowns/AcaYearSelect';
import { getAcaYearList, getAcaYear } from '../../assets/constants/yearList';
import ServerSideGridTable from "../../components/TableGrids/ServerSideGridTable.table";
import GridTable from "../../components/TableGrids/GridTable.table";
import { anchorTag, hccSeperator, numberWithCommas,anchorTagnumberWithCommas } from '../../assets/constants/customRender'
import history from "../../history";
import {  MAO_Allowed_Disallowed_Period, MAO_Allowed_Disallowed_Type,MAO_Allowed_Disallowed_Year,MAO_Allowed_Disallowed_Reasoncode  } from "../../assets/constants/string.constants";
import { percentFormat } from "../../assets/helpers/formats.helpers";
import CardComponent from "../../components/Cards/card";
import LockOpenIcon from '@material-ui/icons/LockOpen';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceTwoToneIcon from '@material-ui/icons/AccountBalanceTwoTone';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import BarChartIcon from '@material-ui/icons/BarChart';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import GChart from '../../components/GChart/GChart';
import IssuersACA from '../ACA/ACAIssuers.page';
import SlickSlider from '../../components/SlickSlider/SlickSlider';
import SubHeader from '../../components/home/header/subHeader';
import { getViewBySelect } from '../../assets/constants/viewByList';
import { getModelSelect } from '../../assets/constants/modelList';
import { getMetalTierSelect } from '../../assets/constants/metalTierList';
import { getPlanSelect } from '../../assets/constants/planList';
import { getModuleSelect } from '../../assets/constants/moduleList';
import Link from '@material-ui/core/Link';
import { connect } from 'react-redux';
import BarVertical from '../../components/GChart/BarVertical';
import { getMeInitialSelect} from '../../assets/constants/meInitialList';
//import google from "react-google-charts";
const MaoDisallowedSummary = (props) => {

    const [EncounterSummaryData, setEncounterSummaryData] = useState([]);
    const [MAOAllowedDisallowedYear] = useState(localStorage.getItem(MAO_Allowed_Disallowed_Year));
    const [MAOAllowedDisallowedType] = useState(localStorage.getItem(MAO_Allowed_Disallowed_Type));
    const [MAOAllowedDisallowedPeriod] = useState(localStorage.getItem(MAO_Allowed_Disallowed_Period));

    const EncounterSummaryColumns = [
        {
            name: "reasonDescription",
            label: "ENCOUNTER CATEGORY"
        },
        {
            name: "count",
            label: "# ENCOUNTER COUNT",
            options: anchorTagnumberWithCommas
        }
    ]


    const loadEncounterSummaryEncounterSummary = () => {
        api.get('/DisallowedSummary/Maoyear/'+MAOAllowedDisallowedYear+'/Maoper/'+MAOAllowedDisallowedPeriod+'/crflag/'+MAOAllowedDisallowedType)
            .then(res => {
                setEncounterSummaryData(res);
            })
            .catch(err => {
                // console.log(err)
            })
    }

    const EncounterSummaryTableClick = (colData,cellMeta,data,columns) => {
        if ((cellMeta.colIndex === 1) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Reasoncode, data[cellMeta.rowIndex].reasoncode);
            history.push('/layout/medicare/disallowed_claims');
        }
    }

    useEffect(() => {   
        loadEncounterSummaryEncounterSummary();      
    },  [
        props.moduleSelect,
        props.viewBySelect,
        props.modelSelect,
        props.metalTierSelect,
        props.planSelect,
        getAcaYear(),
        getMeInitialSelect()
    ]);

    return (
        <div className="container level-summary">
            <div className="row">
                <div className="col-lg-12 pr-0 pl-0 mb-3">
                    <div className="state-level">
                        <div className="card-header">
                            <SubHeader title={'Disallowed Summary'} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 pr-0 pl-0 mt-4">
                    <CardComponent
                        heading={`ALLOWED/DISALLOWED SUMMARY/PAST YEAR`}
                        body={
                            <div className="box-height-chart">
                                <GridTable
                                    data={EncounterSummaryData}
                                    columns={EncounterSummaryColumns}
                                    onTableClick={EncounterSummaryTableClick}
                                ></GridTable>
                            </div>
                        }></CardComponent>
                </div>

                <div className="col-lg-12 pr-0 pl-0 mt-5"></div>
                <br/>

                <br/>
                <br/> 

            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        moduleSelect: state.moduleFilter.moduleSelect,
        viewBySelect: state.moduleFilter.viewBySelect,
        modelSelect: state.moduleFilter.modelSelect,
        metalTierSelect: state.moduleFilter.metalTierSelect,
        planSelect: state.moduleFilter.planSelect,
        yearSelect: state.moduleFilter.yearSelect,        
        meInitialSelect: state.moduleFilter.meInitialSelect,
    };
  }
export default connect(mapStateToProps)(MaoDisallowedSummary);
